export default "__VITE_ASSET__Dk6nC3N6__"